import React, { useContext } from "react";
import { cleanJoin } from "../../../../utils/stringUtil";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import { anyUploadInProgress } from "../requestSubmissionValidator";
import "./Stepper.scss"

function Stepper({ steps, minWidth = 600 }) {
  const { state, dispatch } = useContext(RequestSubmissionContext);
  const nullHref = null;

  const goToStep = (e, index) =>
    index < state.activeStepIndex && !anyUploadInProgress(state.upload.documents)
      ? dispatch({
        type: "previous",
        n: state.activeStepIndex - index,
      })
      : e.preventDefault();

  return (
    <div className="scrollbar-no-width overflow-x-scroll">
      <ul
        className="steps ul-has-no-dots is-narrow is-hollow has-gaps is-centered has-content-centered"
        style={{ minWidth: minWidth }}
      >

        {(Array.isArray(steps) ? steps : new Array(steps)).map((step, index) => (
          <li
            key={`step${index}`}
            className={cleanJoin(
              "step-item",
              index === state.activeStepIndex ? "is-active is-warning" : "",
              index < state.activeStepIndex ? " is-completed is-success" : "",
            )}
            onClick={(e) => goToStep(e, index)}
          >
            <a href={nullHref} className="has-text-dark">
              <span className={cleanJoin(
                "step-marker",
                index === state.activeStepIndex ? "is-active is-warning" : "",
                index < state.activeStepIndex ? " is-completed is-success" : "",
                index > state.activeStepIndex ? "is-not-clickable" : ""
              )}>{index + 1}</span>
              <div className="step-details mt-6">
                <p className="step-title is-size-6 mb-1">{step.props.label}</p>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Stepper;
